<template>
  <div class="account-boxes">
    <DeployerUiBox
      :box-title="paymentTexts.title"
      :box-text="paymentTexts.text"
    >
      <DeployerAccountPaymentMethods
        :payment-data="accountStore.payment?.AgreementSignedUp"
      />
    </DeployerUiBox>

    <DeployerUiBox
      :box-title="historyTexts.title"
      :box-text="historyTexts.text"
    >
      <DeployerAccountBillingHistory
        :transactions="transactions"
        :transactions-loading="transactionsLoading"
      />
    </DeployerUiBox>
  </div>
</template>

<script setup>
const textsStore = useTextsStore()
const accountStore = useAccountStore()
const paymentTexts = computed(() => textsStore.account.billing.box_payment)
const historyTexts = computed(() => textsStore.account.billing.box_history)

const transactions = ref([])
// Todo: Piotr, please use this for the loading animation
const transactionsLoading = ref(false)

const fetchTransfers = async (wallet) => {
  if (!wallet) console.error('No wallet provided')

  transactionsLoading.value = true
  const response = await $fetch('/api/get-transfers', {
    method: 'POST',
    body: {
      wallet,
      networkId: accountStore.payment?.AgreementSignedUp?.networkId
    }
  })

  if (!response) {
    console.error('Error while fetching transactions:', response)
  } else {
    transactions.value =
      Array.isArray(response) &&
      response.filter(
        (transaction) => transaction.billDate <= Math.round(Date.now() / 1000)
      )
  }

  transactionsLoading.value = false
}

onMounted(async () => {
  if (accountStore.payment?.AgreementSignedUp?.refId) {
    // console.log(accountStore.payment?.AgreementSignedUp?.refId)

    await fetchTransfers(accountStore.payment?.AgreementSignedUp?.refId)
  }
})

watch(
  () => accountStore.payment?.AgreementSignedUp?.refId,
  async (address) => {
    if (address) {
      await fetchTransfers(address)
    }
  }
)
</script>

<style lang="scss" scoped></style>
